<p>offline-card works!</p>
